import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ClosingEventsList from "./ClosingEventsList";

const ClosingEvents = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Closing Events" />
          <ClosingEventsList />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ClosingEvents;
